import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'brand_leads-brands_form_hear_about_faire-click';

/**
 * Focus on "How did you hear about Faire" selector field in brands sign up page. This field is optional.
 */
export function trackBrandLeadsBrandsFormHearAboutFaireClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
